import * as React from 'react';
import { createComponent, EventName } from '@lit-labs/react';
import { YotpoList as Component } from '@yotpo-common/ui-components/components/list';
import { YotpoEvents } from '../enums';

export const YotpoList = createComponent({
	react: React,
	tagName: 'yotpo-list',
	elementClass: Component,
	events: {
		onYotpoChange: YotpoEvents.change as EventName<CustomEvent>,
		onYotpoSelect: YotpoEvents.select as EventName<CustomEvent>
	}
});
